export default __webpack_public_path__ + "static/media/partner-19.213b23e5.png";